import { FC } from 'react';
import { CampaignCreateForm } from './CampaignCreateForm';
import { CampaignUpdateForm } from './CampaignUpdateForm';

interface CampaignFormProps {
  onSuccess?: () => void;
  type?: 'create' | 'update';
  postId?: number;
}

export const CampaignForm: FC<CampaignFormProps> = ({ onSuccess, type = 'create', postId }) => {
  return type === 'create' ? (
    <CampaignCreateForm onSuccess={onSuccess} postId={postId} />
  ) : (
    <CampaignUpdateForm onSuccess={onSuccess} />
  );
};

export default CampaignForm;

